import Icon from "@mui/material/Icon";

// Images
import ListCustomers from "./app/client/ListCustomers";
import {CONSTANTS} from "./app/common/constants";
import UserBadge from "./app/client/UserBadge";
import UserDisplayName from "./app/client/UserDisplayName";
import ListCompanies from "./app/companies/ListCompanies";
import NewCompany from "./app/companies/NewCompany";
import DropIdentity from "./app/client/DropIdentity";
import {dropIdentity, logout} from "./app/common/api/WebApi";
import Inventory from "./app/inventory/Inventory";
import Events from "./app/inventory/Events";
import Client from "./app/client/Client";
import Membership from "./app/inventory/Membership";
import CompanyCustomization from "./app/company/CompanyCustomization";
import Employees from "./app/company/Employees";
import SalesDashboard from "./app/SalesDashboard";
import TaskHistory from "./app/company/TaskHistory";
import DashboardSwitch from "./app/DashboardSwitch";
import ListCommunicationTemplates from "./app/company/ListCommunicationTemplates";
import ListCustomerWaivers from "./app/company/ListCustomerWaivers";
import TaskLists from "./app/company/TaskLists";
import Timesheets from "./app/company/Timesheets";
import LogoBadge from "./app/client/LogoBadge";
import ImportCustomers from "./app/client/ImportCustomers";
import InventoryGiftCards from "./app/inventory/InventoryGiftCards";
import EventTemplates from "./app/company/EventTemplates";
import Vendors from "./app/company/Vendors";
import EmployeeCalendar from "./app/employee/EmployeeCalendar";
import CompanyForms from "./app/company/CompanyForms";
import CafeOptions from "./app/company/CafeOptions";
import CafeOrders from "./app/company/CafeOrders";
import ReleaseNotes from "./app/admin/ReleaseNotes";
import MemberPerks from "./app/client/MemberPerks";
import CompanyDiscountCodes from "./app/company/CompanyDiscountCodes";
import ViewEmployee from "./app/employee/ViewEmployee";
import SwitchLocation from "./app/client/SwitchLocation";
import EventMatrix from "./app/company/EventMatrix";
import CompanyPreferences from "./app/company/CompanyPreferences";
import GenericReport from "./app/reports/GenericReport";
import CashEntry from "./app/cash/CashEntry";
import ViewEventPackages from "./app/inventory/ViewEventPackages";

const routes = [
  {
    type: "collapse",
    key: "psb-home",
    route: "/",
    name: "Dashboard",
    icon: <LogoBadge admin={true}/>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    noCollapse: true,
    component: <DashboardSwitch/>
  },
  {type: "divider", key: "divider-logo", userTypes: [CONSTANTS.UTYPE_CLIENT, CONSTANTS.UTYPE_ADMIN]},

  {type: "title", title: "Admin", key: "admin-title", userTypes: [CONSTANTS.UTYPE_ADMIN]},
  {
    type: "collapse",
    name: <UserDisplayName admin={true}/>,
    key: "admin-item",
    userTypes: [CONSTANTS.UTYPE_ADMIN],
    icon: <UserBadge admin={true}/>,
    collapse: [
      {
        name: <DropIdentity/>,
        title: "Drop Identity",
        key: "drop-identity",
        type: "collapse",
        noCollapse: true,
        href: '#',
        clickHandler: (e) => {
          e.preventDefault();
          e.stopPropagation();
          dropIdentity().then(() => {
            window.location = '/';
          });
        },
        icon: <Icon fontSize="medium">face-5</Icon>,
        userTypes: [CONSTANTS.UTYPE_ADMIN],
        route: "/admin/drop/identity",
      },
      {
        name: "Logout",
        title: "Logout",
        key: "admin-logout",
        route: "/companies/new",
        component: <NewCompany/>,
        href: "#",
        clickHandler: (e) => {
          e.preventDefault();
          e.stopPropagation();
          logout().then(() => {
            window.location = '/';
          });
        },
        icon: <Icon fontSize="medium">map-big</Icon>,
        userTypes: [CONSTANTS.UTYPE_ADMIN]
      },
      {
        name: "New Company",
        title: "New Company",
        key: "companies-new",
        route: "/companies/new",
        component: <NewCompany/>,
        icon: <Icon fontSize="medium">map-big</Icon>,
        userTypes: [CONSTANTS.UTYPE_ADMIN]
      },
    ]
  },
  {type: "divider", key: "divider-admin-1", userTypes: [CONSTANTS.UTYPE_ADMIN]},
  {
    type: "collapse",
    name: "List Companies",
    title: "Companies",
    key: "list-companies",
    noCollapse: true,
    route: "/companies/list",
    component: <ListCompanies/>,
    icon: <Icon fontSize="medium">map-big</Icon>,
    userTypes: [CONSTANTS.UTYPE_ADMIN]
  },
  {
    name: "Release Notes",
    key: "release-notes",
    type: "collapse",
    userTypes: [CONSTANTS.UTYPE_ADMIN],
    noCollapse: true,
    icon: <Icon fontSize="medium">notes</Icon>,
    route: "/templates/release-notes",
    component: <ReleaseNotes />,
  },
  {type: "divider", key: "divider-admin", userTypes: [CONSTANTS.UTYPE_ADMIN]},
  {
    type: "collapse",
    name: <UserDisplayName/>,
    key: "employee",
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    icon: <UserBadge/>,
    collapse: [
      {
        name: "Logout",
        key: "logout",
        href: "#",
        clickHandler: (e) => {
          e.preventDefault();
          e.stopPropagation();
          logout().then(() => {
            window.location = '/';
          });
        },
      },
      {
        name: "My Profile",
        title: "My Profile",
        key: "my-profile",
        route: "/my-profile",
        component: <ViewEmployee/>,
        icon: <Icon fontSize="medium">account-box</Icon>,
        userTypes: [CONSTANTS.UTYPE_CLIENT]
      },

      {
        name: "Switch Location",
        key: "switch-location",
        type: "collapse",
        orgMode: true,
        route: "#switch-location",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        icon: <Icon fontSize="medium">edit_location</Icon>
      },
    ],
  },

  {
    name: "Dashboard",
    type: "collapse",
    key: "",
    route: "/",
    userTypes: [CONSTANTS.UTYPE_CUSTOMER],
    icon: <Icon fontSize="medium">dashboard</Icon>,
    noCollapse: true,
    component: <DashboardSwitch/>,
  },
  {
    name: <SwitchLocation/>,
    key: "switch-location-inline",
    type: "collapse",
    orgMode: true,
    noCollapse: true,
    route: "#switch-location",
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    icon: <Icon fontSize="medium">edit_location</Icon>
  },
  {type: "divider", key: "divider-8", orgMode: true, userTypes: [CONSTANTS.UTYPE_CLIENT]},

  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: <Icon fontSize="medium">coffee</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    collapse: [
      {
        type: "collapse",
        name: "List Customers",
        key: "list-customers",
        route: "/customers/list-customers",
        icon: <Icon fontSize="medium"></Icon>,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        component: <ListCustomers/>,
      },
      {
        type: "collapse",
        name: "Create Customer",
        key: "customers-create",
        route: "/customers/create",
        icon: <Icon fontSize="medium">dashboard</Icon>,
        noCollapse: true,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        component: <Client createNew/>,
      },
    ]
  },
  {type: "divider", key: "divider-9", userTypes: [CONSTANTS.UTYPE_CUSTOMER]},
  {type: "title", title: "Daily Operations", key: "operations-title", userTypes: [CONSTANTS.UTYPE_CUSTOMER]},
  {
    name: "Parties & Events",
    key: "sales-events",
    type: "collapse",
    route: "/sales/events",
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    icon: <Icon fontSize="medium">today</Icon>,
    component: <Events specialEvents={false}/>,
    collapse: [
      {
        name: "Parties",
        key: "parties",
        type: "collapse",
        route: "/sales/parties",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        noCollapse: true,
        icon: <Icon fontSize="medium">cake</Icon>,
        component: <Events specialEvents={true}/>
      },
      {
        name: "Events",
        key: "events",
        type: "collapse",
        route: "/sales/events",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        noCollapse: true,
        icon: <Icon fontSize="medium">cake</Icon>,
        component: <Events specialEvents={false}/>
      },
      {
        name: "Event Builder",
        key: "event-builder",
        type: "collapse",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        companyAdmin: true,
        noCollapse: true,
        icon: <Icon fontSize="medium">date_range</Icon>,
        route: "/templates/event-builder",
        component: <EventTemplates />,
      },
      {
        name: "Add-Ons",
        key: "add-ons",
        type: "collapse",
        route: "/sales/add-ons",
        companyAdmin: true,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        noCollapse: true,
        icon: <Icon fontSize="medium">cake</Icon>,
        component: <Inventory key={'inventory-add-ons'} cafeMode={false} addOns={true} />
      },
      {
        name: "Party Packages",
        key: "party-packages",
        type: "collapse",
        route: "/sales/party-packages",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        noCollapse: true,
        companyAdmin: true,
        icon: <Icon fontSize="medium">cake</Icon>,
        component: <ViewEventPackages />
      },
    ]
  },

  {
    name: "Sales & Insights",
    type: "collapse",
    key: "sales-dashboard",
    route: "/sales/dashboard",
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    noCollapse: true,
    companyAdmin: true,
    icon: <Icon fontSize="medium">grid_view</Icon>,
    component: <SalesDashboard/>
  },

  {
    name: "Cash Register",
    key: "cash-register",
    type: "collapse",
    route: "/cash/register",
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    hasPreference : 'enable_cash_register',
    icon: <Icon fontSize="medium">price_change</Icon>,
    collapse: [
      {
        name: "Add Entry",
        key: "register-entry",
        type: "collapse",
        route: "/cash/register-entry",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        hasPreference : 'enable_cash_register',
        icon: <Icon fontSize="medium">price_change</Icon>,
        component: <CashEntry />,
      },
      {
        name: "Cash Report",
        key: "register-report",
        type: "collapse",
        route: "/cash/register-report",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        hasPreference : 'enable_cash_register',
        icon: <Icon fontSize="medium">price_change</Icon>,
        component: <GenericReport type={'cashregister'} disableCalendar={false} range={true} />,
      },
    ]
  },

  ///// Cafe mode
  {type: "divider", key: "divider-10-01", cafeMode: true, userTypes: [CONSTANTS.UTYPE_CLIENT]},

  {
    type: "collapse",
    name: "Cafe",
    key: "cafe",
    cafeMode: true,
    icon: <Icon fontSize="medium">local_cafe</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    collapse: [
      {
        name: "Orders",
        key: "cafe-orders",
        cafeMode: true,
        route: "/cafe/cafe-orders",
        component: <CafeOrders/>,
      },
      {
        name: "Menu Items",
        key: "cafe-inventory",
        cafeMode: true,
        route: "/cafe/cafe-inventory",
        component: <Inventory key={'cafe'} cafeMode={true} />,
      },
      {
        name: "Cafe Groups",
        key: "cafe-groups",
        cafeMode: true,
        route: "/cafe/cafe-groups",
        component: <CafeOptions/>,
      },

    ],
  },

  ////

  {type: "divider", key: "divider-28", companyAdmin: true, userTypes: [CONSTANTS.UTYPE_CLIENT]},
  {
    name: "Retail",
    key: "sales-inventory",
    type: "collapse",
    companyAdmin: true,
    route: "/sales/inventory",
    icon: <Icon fontSize="medium">shopping_cart</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    noCollapse: true,
    component: <Inventory key={'inventory'} cafeMode={false} />
  },

  {
    type: "collapse",
    name: "Memberships",
    key: "memberships-top",
    companyAdmin: true,
    icon: <Icon fontSize="medium">loyalty</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    collapse: [
      {
        name: "Memberships",
        key: "memberships",
        type: "collapse",
        companyAdmin: true,
        route: "/sales/memberships",
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        noCollapse: true,
        icon: <Icon fontSize="medium">book</Icon>,
        component: <Membership/>
      },

      {
        type: "collapse",
        name: "Member Perks",
        key: "member-perks",
        companyAdmin: true,
        route: "/customers/member-perks",
        icon: <Icon fontSize="medium"></Icon>,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        component: <MemberPerks />,
      }
    ],
  },
  {
    name: "Gift Cards",
    key: "sales-gift-cards",
    type: "collapse",
    companyAdmin: true,
    route: "/sales/gift-cards",
    icon: <Icon fontSize="medium">card_giftcard</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    noCollapse: true,
    component: <InventoryGiftCards />
  },

  {type: "divider", key: "divider-10", companyAdmin: true, userTypes: [CONSTANTS.UTYPE_CLIENT]},
  {
    type: "collapse",
    name: "Company",
    key: "company",
    companyAdmin: true,
    icon: <Icon fontSize="medium">store</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    collapse: [
      {
        name: "Customization",
        key: "customization",
        route: "/company/customization",
        component: <CompanyCustomization />,
      },
      {
        name: "Waivers & Contracts",
        key: "waivers",
        route: "/communication/waivers",
        component: <ListCustomerWaivers />,
      },
      {
        name: "Discount Codes",
        key: "discount-codes",
        route: "/company/discount-codes",
        component: <CompanyDiscountCodes />,
      },

      {
        name: "Event Pricing Matrix",
        key: "event-matrix",
        route: "/company/event-matrix",
        component: <EventMatrix />,
      },
      {
        name: "Preferences",
        key: "preferences",
        route: "/company/preferences",
        component: <CompanyPreferences />,
      },
      {
        name: "Event Forms",
        key: "event-forms",
        route: "/company/event-forms",
        component: <CompanyForms/>,
      },
      {
        name: "Communication",
        key: "templates",
        route: "/communication/templates",
        component: <ListCommunicationTemplates/>,
      },
      {
        name: "Import Customers",
        key: "import-customers",
        route: "/company/import-customers",
        icon: <Icon fontSize="medium"></Icon>,
        component: <ImportCustomers/>,
      }
    ],
  },

  {
    type: "collapse",
    name: "Tasks",
    key: "tasks",
    icon: <Icon fontSize="medium">playlist_add_check</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    companyAdmin: true,
    collapse: [
      {
        type: "collapse",
        name: "Tasks History",
        key: "history",
        route: "/tasks/history",
        noCollapse: true,
        companyAdmin: true,
        icon: <Icon fontSize="medium"></Icon>,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        component: <TaskHistory/>,
      },
      {
        type: "collapse",
        name: "Manage Tasks",
        key: "manage-tasks",
        route: "/tasks/manage-tasks",
        noCollapse: true,
        companyAdmin: true,
        icon: <Icon fontSize="medium">plus</Icon>,
        userTypes: [CONSTANTS.UTYPE_CLIENT],
        component: <TaskLists />,
      }
      ]
  },
  {type: "divider", key: "divider-20", userTypes: [CONSTANTS.UTYPE_CLIENT]},
  {type: "title", title: "Products", key: "title-sales", userTypes: [CONSTANTS.UTYPE_CUSTOMER]},



  {
    type: "collapse",
    name: "Employees",
    key: "employees-top",
    companyAdmin: true,
    icon: <Icon fontSize="medium">supervised_user_circle_icon</Icon>,
    userTypes: [CONSTANTS.UTYPE_CLIENT],
    collapse: [
      {
        name: "Employees",
        companyAdmin: true,
        key: "employees",
        route: "/company/employees",
        component: <Employees/>,
      },
      {
        name: "Vendors",
        companyAdmin: true,
        key: "vendors",
        route: "/company/vendors",
        component: <Vendors/>,
      },
      {
        name: "Calendar",
        companyAdmin: true,
        key: "employee-calendar",
        route: "/company/employee-calendar",
        component: <EmployeeCalendar/>,
      },
      {
        name: "Time Sheets",
        companyAdmin: true,
        key: "time-sheets",
        route: "/company/time-sheets",
        component: <Timesheets/>,
      },
    ],
  },

  {type: "divider", key: "divider-999", companyAdmin: true, userTypes: [CONSTANTS.UTYPE_CLIENT]},

];

export default routes;
